import type { GridProps } from '@chakra-ui/react'
import { Grid } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface PageSectionMenuProps extends GridProps { }

export const PageSectionMenu = forwardRef(
  ({ children, ...rest }: PageSectionMenuProps, ref) => {
    return (
      <Grid
        ref={ref}
        sx={{
          display: { base: 'none', md: 'grid' },
          gap: 0,
          alignContent: 'start',
          position: { base: 'static', md: 'sticky' },
          top: 0,
          bottom: 0,
          pl: { md: 4 },
          zIndex: 2,
          _after: {
            content: '""',
            position: 'absolute',
            width: 'calc(100% - 3px)',
            top: -12,
            bottom: 0,
            left: 0,
            right: '3px',
            zIndex: 2,
            bg: 'neutral.50'
          },
          _before: {
            content: '""',
            position: 'absolute',
            width: 'calc(100% - 3px)',
            height: 4,
            top: '100%',
            left: 0,
            right: '3px',
            layerStyle: 'menuGradient',
            zIndex: -1,
          },
        }}
        {...rest}
      >
        {children}
      </Grid>
    )
  },
)
